<template>
  <div>
    <el-row type="flex" justify="space-between" align="middle">
      <el-col :span="10"><div class="materialDialog-text">選擇視頻</div></el-col>
      <el-col :span="3" style="text-align:right;font-size:20px;cursor: pointer;"><i @click="onIconClose" class="el-icon-close"></i></el-col>
    </el-row>
    <el-row
      type="flex"
      justify="space-between"
      align="middle"
      class="upload-justify"
    >
      <el-col :span="6">素材庫</el-col>
      <el-col :span="6" style="text-align:right;">
        <upload
          placeholder="請選擇影片"
          buttonText="上傳影片"
          :isShowInput="true"
          :isImgUpload="false"
          :file-type="videoFileType"
          @childByValue="childByVideoUrl"
          @imgFile="imgFile"
        ></upload>
      </el-col>
    </el-row>
    <template v-for="(item, index) in materials">
      <el-row
        class="row-list"
        :key="item.id"
        v-if="index % 3 == 0"
        type="flex"
        :gutter="10"
      >
        <el-col
          :span="8"
          v-for="(v, j) in materials.slice(index, index + 3)"
          :key="`y` + j"
        >
          <el-card class="box-card" shadow="hover">
            <el-row type="flex" :gutter="10">
              <el-col :span="14" class="video-card">
                <videoPlayer class="videoPlayer" :videoUrl="v.fileUrl"></videoPlayer>
              </el-col>
              <el-col :span="10" class="col-box">
                <div class="video-name">{{ v.fileName }}</div>
                <div>{{ v.createdAt | formatDateTime }}</div>
                <el-button
                  type="info"
                  class="browse-button"
                  @click="onCardBox(v.fileUrl)"
                >
                  選擇視頻</el-button
                >
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </template>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="formLabelAlign._page"
      :limit.sync="formLabelAlign._limit"
      @pagination="getMaterials"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import moment from "moment";
import videoPlayer from "./videoPlayer";
import upload from "@/components/upload";
import { getMaterials, addMaterials } from "@/api/practises";
export default {
  components: { upload, videoPlayer, Pagination },
  data() {
    return {
      total: 0,
      videoFileType: [
        "avi",
        "mp4",
        "mov",
        "mkv",
        "flv",
        "wmv",
        "rmvb",
        "mpeg",
        "m4v",
        "asf",
        "f4v",
        "rm",
        "3gp",
        "vob",
      ],
      materials: [],
      formLabelAlign: {
        _page: 0,
        _limit: 10,
      },
    };
  },
  created() {
    this.getMaterials();
  },
  methods: {
    onIconClose(){
      this.$emit("iconClose");
    },
    onCardBox(v) {
      this.$emit("childVideoUrl", v);
    },
    imgFile(v) {
      this.fileName = v;
    },
    childByVideoUrl(v) {
      this.addMaterials(v);
    },
    getMaterials() {
      let from = {
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getMaterials(from).then((res) => {
        this.materials = res.data;
        this.total = Number(res.headers["x-total-count"]);
      });
    },
    addMaterials(v) {
      let from = {
        fileName: this.fileName,
        fileUrl: v,
        createdAt: moment().format("YYYY/MM/DD HH:mm"),
      };
      addMaterials(from).then(() => {
        this.getMaterials();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.materialDialog-text{
    font-size:20px;
}
.row-list {
  margin-bottom: 20px;
}
.upload-justify {
  margin-bottom: 20px;
  border-bottom:1px solid #ccc;
  padding-bottom: 10px;
  margin-top: 20px;
}
.box-card {
  height: 200px;
}
.video-card{
    height: 133px;
}
.videoPlayer{
    height: 100%;
}
.col-box{
    display: flex;
    flex-direction: column;
    justify-content: space-between
}
.video-name{
    //强制换行
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>